exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ai-informations-dropdown-menu{min-height:50px;padding:.5rem;background:#fff;border:1px solid #ddd;text-align:center;color:#aaa}.header-options{display:flex;justify-content:flex-end;margin-bottom:8px;font-size:12px;margin-top:4px;margin-right:6px;color:var(--fts-default);cursor:pointer}.header-options .icon{color:var(--fts-primary)}.header-options .icon-disabled{color:var(--fts-border)}.button-wrapper{bottom:0;right:0;padding-top:1rem}", ""]);

// exports
